<template>
  <div>
    <v-toolbar
      tabs
      :style="{
        zIndex: 1,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: '#ccc',
        marginBottom: '20px',
        paddingBottom: '20px',
      }"
      height="80"
      card
      color="#fff"
    >
      <v-layout row align-center justify-space-between>
        <v-flex grow>
          <div
            class="mr-3"
            :style="{
              padding: '8px',
              display: 'inline-block',
              backgroundColor: '#ef565c',
              borderRadius: '0.5rem',
            }"
          >
            <v-icon color="#fff" medium>alarm</v-icon>
          </div>
          <h1 style="display: inline">Reporte de permisos de terceros</h1>
        </v-flex>
        <router-link :to="{ name: 'Reports' }">
          <v-icon>close</v-icon>
        </router-link>
      </v-layout>

      <v-speed-dial
        key="1"
        absolute
        bottom
        left
        direction="bottom"
        open-on-hover
        transition="scale-transition"
        style="bottom: 0"
      >
        <template v-slot:activator>
          <v-btn color="gradiente" dark fab>
            <v-icon>more_vert</v-icon>
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>
        <v-tooltip right>
          <v-btn
            fab
            dark
            small
            color="gradiente"
            slot="activator"
            @click="downloadPdf"
          >
            <v-icon>file_download</v-icon>
          </v-btn>
          <span>Descargar PDF</span>
        </v-tooltip>
        <v-tooltip right>
          <v-btn
            fab
            dark
            small
            color="gradiente"
            slot="activator"
            @click="downloadXlsx"
          >
            <v-img
              :style="{ flex: '0 1 auto' }"
              height="28px"
              width="28px"
              :src="require('@/assets/reports/IconoCSV.png')"
            />
          </v-btn>
          <span>Descargar XLSX</span>
        </v-tooltip>
      </v-speed-dial>
    </v-toolbar>
    <v-container
      fluid
      grid-list-xl
      style="
        padding: 20px;
        height: 90vh;
        overflow: scroll;
        padding-bottom: 120px !important;
      "
    >
      <v-layout row wrap>
        <v-flex xs12 style="padding: 0 12px 10px">
          <v-card flat class="border-container">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm4 md3>
                  <v-menu
                    :close-on-content-click="false"
                    :nudge-left="500"
                    :nudge-width="500"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    max-width="600px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        label="Buscar"
                        class="border-container"
                        prepend-inner-icon="search"
                        clearable
                        solo
                        flat
                        hide-details
                        v-model="filters.search"
                      >
                        <template v-slot:append>
                          <v-icon v-on="on">tune</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-card>
                      <v-card-text>
                        <v-layout row wrap>
                          <!-- initial date -->
                          <v-flex xd12 sm12 md12 pa-1>
                            <div class="border-container px-3">
                              <v-layout row wrap align-center>
                                <v-flex xs5 sm4 pr-0>Fecha de inicio</v-flex>
                                <v-flex xs7 sm8 pl-0 ml>
                                  <v-menu
                                    :close-on-content-click="true"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                  >
                                    <template late v-slot:activator="{ on }">
                                      <v-text-field
                                        id="first-small"
                                        :value="dateParse(timeFirst)"
                                        label="Fecha de inicio"
                                        prepend-icon="event"
                                        readonly
                                        solo
                                        flat
                                        hide-details
                                        v-on="on"
                                        class="padded"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      header-color="primary"
                                      color="secondary"
                                      locale="es-419"
                                      scrollable
                                      :min="today"
                                      :max="timeLast"
                                      v-model="timeFirst"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-flex>
                              </v-layout>
                            </div>
                          </v-flex>
                          <!-- final date -->
                          <v-flex xd12 sm12 md12 pa-1>
                            <div class="border-container px-3">
                              <v-layout row wrap align-center>
                                <v-flex xs5 sm4 pr-0> Fecha de término</v-flex>
                                <v-flex xs7 sm8 pl-0>
                                  <v-menu
                                    :close-on-content-click="true"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                        id="last-small"
                                        :value="dateParse(timeLast)"
                                        label="Fecha de término"
                                        prepend-icon="event"
                                        readonly
                                        v-on="on"
                                        solo
                                        flat
                                        hide-details
                                        class="padded"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      header-color="primary"
                                      color="secondary"
                                      locale="es-419"
                                      scrollable
                                      :min="timeFirst"
                                      :max="limitLastDate"
                                      v-model="timeLast"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-flex>
                              </v-layout>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                      <v-card-actions
                        style="justify-content: end; margin-right: 8px"
                      >
                        <v-flex
                          xd12
                          sm7
                          md4
                          style="display: flex; justify-content: end"
                        >
                          <v-btn
                            @click="filterClear"
                            v-show="showFilter"
                            color="primary"
                          >
                            <v-icon left>close</v-icon>
                            Limpiar filtros
                          </v-btn>
                        </v-flex>
                      </v-card-actions>
                    </v-card>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 style="padding: 0 12px 10px">
          <v-card flat class="border-container">
            <v-card-text class="px-0 py-0">
              <v-data-table
                :rows-per-page-items="[25, 50, 100]"
                rows-per-page-text="Registros por página"
                :headers="headers"
                :items="items"
                :total-items="totalItems"
                :loading="isLoadingTable"
                :pagination.sync="pagination"
                @update:pagination="customPaginator"
                no-results-text="No se encontraron coincidencias"
                no-data-text="No hay registros"
                must-sort
              >
                <template v-slot:headers="props">
                  <tr>
                    <th v-for="header in props.headers" :key="header.text">
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <v-progress-linear
                  v-slot:progress
                  color="primary"
                  indeterminate
                ></v-progress-linear>
                <template v-slot:items="props">
                  <tr>
                    <td>{{ props.item.firstName }}</td>
                    <td>{{ props.item.lastName }}</td>
                    <td>
                      <v-avatar size="30px">
                        <img
                          v-if="
                            props.item.imageStorage &&
                            props.item.imageStorage.miniObjUrl
                          "
                          :src="props.item.imageStorage.miniObjUrl"
                          :alt="
                            props.item.firstName + ' ' + props.item.lastName
                          "
                        />
                        <v-icon v-else>account_circle</v-icon>
                      </v-avatar>
                    </td>
                    <td>
                      <span
                        v-if="isSameDay(props.item.start)"
                        class="green--text font-weight-medium body-2"
                      >
                        Hoy
                      </span>
                      <span
                        v-else
                        class="yellow--text font-weight-medium body-2"
                      >
                        Próximas
                      </span>
                    </td>
                    <td
                      class="text-xs-left"
                      style="width: 120px; max-width: 120px; min-width: 120px"
                      @click="props.expanded = !props.expanded"
                    >
                      <v-btn icon>
                        <v-badge
                          :color="props.item.students.length ? 'green' : 'red'"
                        >
                          <template v-slot:badge>
                            <span>{{ props.item.students.length }}</span>
                          </template>
                          <v-icon class="no-border">
                            {{
                              !props.item.students.length
                                ? 'person_outline'
                                : props.item.students.length == 1
                                ? 'person'
                                : 'group'
                            }}
                          </v-icon>
                        </v-badge>
                      </v-btn>
                    </td>
                    <td>{{ dateParse(props.item.start) }}</td>
                    <td>
                      {{
                        props.item.end
                          ? dateParse(props.item.end)
                          : dateParse(props.item.start)
                      }}
                    </td>
                  </tr>
                </template>
                <template v-slot:expand="props">
                  <StudentsTable :items="props.item.students" />
                </template>
                <template v-slot:no-data>
                  <div
                    v-if="
                      (totalItems === 0 || totalItems === undefined) &&
                      showFilter === true
                    "
                  >
                    No hay registros para filtrar
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <Error v-model="modals.showError" :text="modals.errorText"> </Error>
    <Success v-model="modals.showSuccess" :text="modals.successText"> </Success>
    <Loading v-model="modals.showLoading" text="Cargando..."> </Loading>
  </div>
</template>

<script>
import moment from 'moment'
import {
  _downloadFileFromContentDisposition,
  _isSomeDifferent,
} from '../../../../utils/genericUtils.js'
import Error from '../../../Dialogs/Error.vue'
import Loading from '../../../Dialogs/Loading.vue'
import Success from '../../../Dialogs/Success.vue'
import StudentsTable from './studentsTable.vue'
export default {
  components: {
    Error,
    Success,
    Loading,
    StudentsTable,
  },
  data() {
    return {
      modals: {
        showError: false,
        errorText: '',
        showSuccess: false,
        successText: '',
        showLoading: false,
      },
      today: moment().format('YYYY-MM-DD'),
      timeFirst: moment().format('YYYY-MM-DD'),
      timeLast: moment().format('YYYY-MM-DD'),
      limitLastDate: new Date(
        new Date().setDate(new Date().getDate() + 30)
      ).toLocaleDateString('sv-SE'),
      filters: {
        search: '',
      },
      showFilter: false,
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 25,
        sortBy: 'NAME',
      },
      headers: [
        {
          text: 'Nombre',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Apellido',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Foto',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Estatus',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Autorizados',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Fecha de inicio',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Fecha de fin',
          sortable: false,
          align: 'center',
        },
      ],
      isLoadingTable: false,
      items: [],
      totalItems: 0,
    }
  },
  created() {
    this.getItems(true)
  },
  methods: {
    customPaginator() {
      this.getItems()
    },
    async getItems(isInitialStateParams = false) {
      const params = {
        search: this.filters.search,
        from: this.timeFirst,
        to: this.timeLast,
        offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
        size: this.pagination.rowsPerPage,
      }

      if (isInitialStateParams === true) {
        const tempObj = structuredClone(params)
        const tempParams = Object.keys(tempObj)
          .filter((e) => tempObj[e] !== undefined)
          .map((e) => `${e}_${tempObj[e]}`)
        this.initialStateParams = tempParams
        return
      }

      const tempObj = structuredClone(params)
      const tempParams = Object.keys(params)
        .filter((e) => tempObj[e] !== undefined)
        .map((e) => `${e}_${tempObj[e]}`)

      this.showFilter = _isSomeDifferent(this.initialStateParams, tempParams)

      this.isLoadingTable = true
      try {
        const { data } = await this.$store.dispatch(
          'reports/getThirdQrReport',
          params
        )

        this.items = data.data
        this.totalItems = data.total
      } catch (error) {
        console.log(error)
        this.items = []
        this.totalItems = 0
      } finally {
        this.isLoadingTable = false
      }
    },
    async downloadPdf() {
      const params = {
        search: this.filters.search === '' ? undefined : this.filters.search,
        from: this.timeFirst,
        to: this.timeLast,
      }

      this.modals.showLoading = true
      try {
        const response = await this.$store.dispatch(
          'reports/getThirdQrPdf',
          params
        )

        _downloadFileFromContentDisposition({ response })
        this.modals.showLoading = false
        this.modals.showSuccess = true
        this.modals.successText = 'Descarga exitosa'
      } catch (error) {
        console.log(error)
        this.modals.showLoading = false
        this.modals.showError = true
        this.modals.errorText = 'Error al descargar pdf'
      }
    },
    async downloadXlsx() {
      const params = {
        search: this.filters.search === '' ? undefined : this.filters.search,
        from: this.timeFirst,
        to: this.timeLast,
      }

      this.modals.showLoading = true
      try {
        const response = await this.$store.dispatch(
          'reports/getThirdQrXlsx',
          params
        )

        _downloadFileFromContentDisposition({ response })
        this.modals.showLoading = false
        this.modals.showSuccess = true
        this.modals.successText = 'Descarga exitosa'
      } catch (error) {
        console.log(error)
        this.modals.showLoading = false
        this.modals.showError = true
        this.modals.errorText = 'Error al descargar archivo'
      }
    },
    dateParse(date) {
      if (date != null) {
        return moment(date).format('DD/MM/YYYY')
      }
      return '-'
    },
    isSameDay(date) {
      return moment(this.today).isSame(date, 'day')
    },
    filterClear() {
      this.pagination.page = 1
      this.pagination.rowsPerPage = 25
      this.showFilter = false
      this.timeFirst = moment().format('YYYY-MM-DD')
      this.timeLast = moment().format('YYYY-MM-DD')
      this.filters.search = ''
    },
  },
  watch: {
    timeFirst() {
      if (this.timeFirst === null || this.timeLast === null) return
      this.getItems()
    },
    timeLast() {
      if (this.timeFirst === null || this.timeLast === null) return
      this.getItems()
    },
    'filters.search': function () {
      this.getItems()
    },
  },
}
</script>

<style scoped>
.border-container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
  overflow: hidden;
}
::v-deep .v-input__prepend-outer {
  margin-right: -1px !important;
}

::v-deep .padded .v-input__slot {
  padding-left: 8px !important;
}

::v-deep .v-datatable.v-table > thead {
  display: table;
  width: 100%;
  table-layout: fixed;
}

table.v-table > thead tr {
  background-color: #dddddd;
  height: 40px;
}

::v-deep .v-datatable.v-table > tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

@media (max-width: 600px) {
  ::v-deep .v-datatable.v-table > thead {
    display: block;
  }
}
</style>
